/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */

import translations from '@atlaskit/afm-i18n-platform-media-media-ui/i18n/en';
export default translations;
